<template>
    <header class="sheet-header" :class="{'white-version': isBestSeller,'absolute': vueTourOn}">
        <h1 class="product-title">
            <button class="icon-arrow-left" @click="returnRouteEvent()"></button>
            {{ productName }}
        </h1>
        <nav class="sheet-navigation" :data-v-step=" !isPhone ? 'argument-4' : ''">
            <template v-if="isBestSeller">

                <a
                    v-for="(navigationItem, index) in navigationItems"
                    :key="navigationItem.identifier"
                    href="javascript:;"
                    class="sheet-navigation-link"
                    :class="{current: currentNavigationIndex === index}"
                    :data-v-step="isPhone ? '' : navigationItem.name"
                    @click="navigationTabClicked(index)"
                >
                    <span>{{ navigationItem.label }}</span>
                    <span class="bottom-line"></span>
                </a>

            </template>
            <template v-else>
                <router-link
                    v-for="(navigationItem, index) in navigationItems"
                    :key="navigationItem.route.name"
                    :to="navigationItem.route"
                    v-if="!navigationItem.isBestSellerTrigger"
                    class="sheet-navigation-link"
                    :class="{current: currentNavigationIndex === index}"
                    :data-tracking="navigationItem.code ? `${$route.meta.sheetType}_sheet__link__${navigationItem.code}` : null"
                    @click="navigationTabClicked(index)"
                    :data-v-step="isPhone ? '' : navigationItem.route.name"
                >
                    <span>{{ navigationItem.label }}</span>
                    <span class="bottom-line"></span>
                </router-link>
            </template>
        </nav>
        <b-dropdown
            :data-v-step="isPhone ? 'argument-4' : ''"
            aria-role="menu"
            class="mobile-sheet-navigation"
            @active-change="isDropdownOpen = $event">
            <button
                type="button"
                slot="trigger"
                class="navbar-item"
                :data-v-step="isPhone ? 'machine-sheet-capacity' : ''">
                <div class="burger">
                    <span class="burger-line"></span>
                    <span class="burger-line"></span>
                    <span class="burger-line"></span>
                </div>
                <span>{{ navigationItems[currentNavigationIndex].label }}</span>
            </button>
            <template v-if="isBestSeller">
              <button class="trigger-standard-view" @click="$bus.$emit('setBestSellerPanel', false)"></button>
              <b-dropdown-item
                  aria-role="menu-item"
                  has-link
                  value="standard"
              >
                <a
                    href="javascript:;"
                    class="mobile-sheet-navigation-link"
                    @click="$bus.$emit('setBestSellerPanel', false)"
                >
                  <span>{{ $t("product_return") }}</span>
                </a>
              </b-dropdown-item>
              <template v-if="navigationItems.length>1">
                <b-dropdown-item
                    aria-role="menu-item"
                    has-link
                    v-for="(navigationItem, index) in navigationItems"
                    :key="navigationItem.identifier"
                    :value="index"
                >
                    <a
                        href="javascript:;"
                        class="mobile-sheet-navigation-link"
                        @click="navigationTabClicked(index)"
                    >
                        <span>{{ navigationItem.label }}</span>
                    </a>
                </b-dropdown-item>
              </template>
            </template>
            <template v-else>
                <b-dropdown-item
                    aria-role="menu-item"
                    has-link
                    v-for="(navigationItem, index) in navigationItems"
                    :key="navigationItem.label"
                    v-if="!navigationItem.isBestSellerTrigger || (hasBestSeller && navigationItem.isBestSellerTrigger)"
                    :value="index"
                >
                    <template v-if="navigationItem.isBestSellerTrigger">
                        <a
                            href="javascript:;"
                            class="mobile-sheet-navigation-link"
                            @click="navigationTabClicked(index)"
                        >
                            <span>{{ navigationItem.label }}</span>
                        </a>
                    </template>
                    <template v-else>
                        <router-link
                            :to="navigationItem.route"
                            class="mobile-sheet-navigation-link"
                            :data-tracking="navigationItem.code ? `${$route.meta.sheetType}_sheet__link__${navigationItem.code}` : null"
                            @click="navigationTabClicked(index)"
                        >
                            <span>{{ navigationItem.label }}</span>
                        </router-link>
                    </template>
                </b-dropdown-item>
            </template>
        </b-dropdown>
    </header>
</template>

<script>
    import { mapState } from 'vuex'

    import removeAccents from 'remove-accents'

    export default {
        name: 'SheetHeader',
        props: {
            productDatas: {
                type: Object,
                required: true
            },
            hasBestSeller: {
                type: Boolean,
                default: false
            },
            isBestSeller: {
                type: Boolean,
                default: false
            },
            bestSellerFinitions: {
                type: Array,
                default: () => []
            },
            menu_service: {
              type: Array,
              default: () => []
            },
        },
        data() {
            return {
                isDropdownOpen: false,
                currentFinitionIndex: 0,
                pictures: [],

            }
        },
        computed: {
            ...mapState({
                returnRoute: state => state.sheet.returnRoute,
              marketFilter: state => state.searchMachines.marketFilter,
              isPhone: state => state.settings.isPhone,
              vueTourOn: state => state.vuetour.vueTourOn,
            }),
            productName() {
                let name = null;
                if(this.$route.meta.sheetType === 'machine')
                    name = (this.productDatas.name || this.productDatas.values.reference_name)
                else if(this.$route.meta.sheetType === 'accessory')
                    name = (this.productDatas.name || this.productDatas.values.attachment_name || this.productDatas.values.name )
                else if(this.$route.meta.sheetType === 'service')
                    name = (this.productDatas.name || this.productDatas.values.service_name);
                else if(this.$route.meta.sheetType === 'innovations')
                  name = (this.productDatas.name || this.productDatas.values.innovation_name);

                if(name)
                    return removeAccents(name);
                else
                    return this.productDatas.identifier
            },
            currentNavigationIndex() {
                if(this.isBestSeller)
                    return this.currentFinitionIndex;
                else
                    return this.navigationItems.findIndex(x => x.route.name === this.$route.name);
            },
            navigationItems() {
                if(this.isBestSeller){
                    return this.bestSellerFinitions;
                }
                else{
                    const productIdentifier = (this.productDatas.parent ? this.productDatas.parent : this.productDatas.identifier);
                    if(this.$route.meta.sheetType === 'machine'){
                      this.menu_machine= [
                        { label: this.$t('in_brief'), code: 'in_brief', route: {name: 'machine-sheet-summary', params: {id: productIdentifier, name: this.slugifyName(this.productDatas)}}},
                          ]
                      if(this.productDatas.guide) this.menu_machine.push( { label: this.$t('handover'), code: 'handover', route: {name: 'machine-sheet-handover', params: {id: productIdentifier, name: this.slugifyName(this.productDatas)}}})

                      this.menu_machine.push(  { label: this.$t('showroom'), code: 'showroom', route: {name: 'machine-sheet-showroom', params: {id: productIdentifier, name: this.slugifyName(this.productDatas)}}},
                          { label: this.$t('documents'), code: 'documents', route: {name: 'machine-sheet-documents', params: {id: productIdentifier, name: this.slugifyName(this.productDatas)}}})

                      if(this.productDatas.compendium && (this.productDatas.compendium.arguments || this.productDatas.compendium.objections)) this.menu_machine.push({ label: this.$t('arguments'), code: 'arguments', route: {name: 'machine-sheet-arguments', params: {id: productIdentifier, name: this.slugifyName(this.productDatas)}}})

                      this.menu_machine.push(
                        { label: this.$t('features'), code: 'features', route: {name: 'machine-sheet-features', params: {id: productIdentifier, name: this.slugifyName(this.productDatas)}}}
                      )

                      if(this.productDatas.attachments_products.length>0)
                      this.menu_machine.push(
                           { label: this.$t('accessories'), code: 'accessories', route: {name: 'machine-sheet-accessories', params: {id: productIdentifier, name: this.slugifyName(this.productDatas)}}}
                      )

                      if(this.productDatas.options && Object.keys(this.productDatas.options).length > 0)
                      this.menu_machine.push(
                        { label: this.$t('equipments'), code: 'equipments', route: {name: 'machine-sheet-equipments', params: {id: productIdentifier, name: this.slugifyName(this.productDatas)}}}
                      )

                      if(this.productDatas.compendium && this.productDatas.compendium.competitors) this.menu_machine.push({ label: this.$t('to_compare'), code: 'to_compare', route: {name: 'machine-sheet-compare', params: {id: productIdentifier, name: this.slugifyName(this.productDatas)}}})

                      if(this.productDatas.has_capacity) this.menu_machine.push({ label: this.$t('capacity'), code: 'capacity', route: {name: 'machine-sheet-capacity', params: {id: productIdentifier, name: this.slugifyName(this.productDatas)}}})
                      if(this.productDatas.has_autonomy) this.menu_machine.push({ label: this.$t('autonomy'), code: 'autonomy', route: {name: 'machine-sheet-autonomy', params: {id: productIdentifier, name: this.slugifyName(this.productDatas)}}})
                      this.menu_machine.push({ label: this.$t('best_seller'), isBestSellerTrigger: true})

                      return this.menu_machine;

                    }
                    else if(this.$route.meta.sheetType === 'accessory'){
                        return [
                            { label: this.$t('in_brief'), code: 'in_brief', route: {name: 'accessory-sheet-summary', params: {id: productIdentifier, name: this.slugifyName(this.productDatas)}}},
                            { label: this.$t('showroom'), code: 'showroom', route: {name: 'accessory-sheet-showroom', params: {id: productIdentifier, name: this.slugifyName(this.productDatas)}}},
                            { label: this.$t('documents'), code: 'documents', route: {name: 'accessory-sheet-documents', params: {id: productIdentifier, name: this.slugifyName(this.productDatas)}}},
                            { label: this.$t('features'), code: 'features', route: {name: 'accessory-sheet-features', params: {id: productIdentifier, name: this.slugifyName(this.productDatas)}}},
                        ]
                    }
                    else if(this.$route.meta.sheetType === 'service'){

                       this.menu_service= [
                         { label: this.$t('in_brief'), code: 'in_brief', route: {name: 'service-sheet-summary', params: {id: productIdentifier, name: this.slugifyName(this.productDatas)}}},
                       ]

                      if(this.getEnv!=="production")  this.menu_service.push({ label: this.$t('showroom'), code: 'showroom', route: {name: 'service-sheet-showroom', params: {id: productIdentifier, name: this.slugifyName(this.productDatas)}}})

                      this.menu_service.push({ label: this.$t('documents'), code: 'documents', route: {name: 'service-sheet-documents', params: {id: productIdentifier, name: this.slugifyName(this.productDatas)}}})

//test faq
                      if(this.productDatas.pages && this.productDatas.pages.faq.lines.length>0) this.menu_service.push({ label: this.$t('step_faq'), code: 'faqs', route: {name: 'service-sheet-faqs', params: {id: productIdentifier, name: this.slugifyName(this.productDatas)}}})

                      return this.menu_service;
                    } else if(this.$route.meta.sheetType === 'innovations') {
                      this.menu_innovation = [
                        { label: this.$t('in_brief'), code: 'in_brief', route: {name: 'innovation-sheet-summary', params: {id: productIdentifier, name: this.slugifyName(this.productDatas)}}},
                      ]

                      let mediasAttributes = [
                        'studio',
                        'application',
                        'detail',
                      ];

                      for(const mediasAttribute of mediasAttributes)
                        this.fetchShowroomMedias(mediasAttribute);

                      if (this.productDatas.values.youtube_other !== undefined || this.pictures.length > 0)
                        this.menu_innovation.push({ label: this.$t('showroom'), code: 'showroom', route: {name: 'innovation-sheet-showroom', params: {id: productIdentifier, name: this.slugifyName(this.productDatas)}}});

                      return this.menu_innovation;
                    }
                }
            },
        },
        created(){
            this.$bus.$on('refreshProductFinitionDatas', (identifier) => {
                this.currentFinitionIndex = this.bestSellerFinitions.findIndex(x => x.identifier === identifier);
            });
        },
        methods: {
            navigationTabClicked(index){
                let navigationItem = this.navigationItems[index];
                if(this.isBestSeller)
                    this.$bus.$emit('refreshProductFinitionDatas', navigationItem.identifier);
                else if(navigationItem.isBestSellerTrigger)
                        this.$bus.$emit('setBestSellerPanel', true)
            },
            returnRouteEvent() {
                if(this.isBestSeller)
                    this.$bus.$emit('setBestSellerPanel', false)
                else {
                    let returnRoute = {name: 'search', query:{return:1}};

                    if(this.returnRoute && (this.$route.name !== this.returnRoute.name)) {
                      returnRoute = this.returnRoute
                      returnRoute = {...returnRoute, query:{return:1}}
                    } else {
                      if(this.$route.name.indexOf('machine-sheet')>-1)   returnRoute={name: 'search-machines', query : {init:1}}
                      if(this.$route.name.indexOf('accessory-sheet')>-1) returnRoute={name: 'search-accessories' , query : {init:1}}
                      if(this.$route.name.indexOf('service-sheet')>-1)   returnRoute={name: 'search-services' , query : {init:1}}
                      if(this.$route.name.indexOf('innovation-sheet')>-1)   returnRoute={name: 'search-innovations' , query : {init:1}}

                    }
                    this.$router.push({name:returnRoute.name, query: returnRoute.query})
                }
            },
        }
    };
</script>

<style lang="scss">

.absolute {
  position:absolute!important
}
    .sheet-header {
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 1000;

        &:not(.white-version){
            .product-title {
                @each $brand in $brands {
                    .brand-#{$brand} & {
                        color: $white;
                        background-color: $brand-red;
                    }
                }
            }
        }

        .product-title {
            display: flex;
            align-items: center;
            color: $brand-red;
            height: $product-sheet-title-height;
            background-color: $white;
            font-family: $font_manitou;
            text-transform: uppercase;
            font-size: 23px;
            font-weight: 800;

            @media #{$mq_phone} {
                font-size: 15px;
                height: $product-sheet-title-height-mobile;
            }

            .icon-arrow-left {
                cursor: pointer;
                height: 100%;
                padding: 0 20px;
                display: flex;
                align-items: center;
            }
        }

        .sheet-navigation {
            display: flex;
            justify-content: space-between;
            height: $product-sheet-navigation-height;
            background-color: $blackish;
            text-align: center;

            @media #{$mq_phone} {
                display: none;
            }

            .sheet-navigation-link {
                flex: 1 1 auto;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 0 10px;
                color: $white;
                position: relative;

                &:hover, &.current {
                    .bottom-line {
                        opacity: 1;
                    }
                }

                .bottom-line {
                    opacity: 0;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    height: 7px;
                    background-color: $white;
                    transition: opacity 0.3s ease;

                    @each $brand in $brands {
                        .brand-#{$brand} & {
                            background-color: $brand-red;
                        }
                    }
                }
            }

        }
      &.white-version{
        .sheet-navigation .sheet-navigation-link .bottom-line{
          background-color:#ffffff;
        }
      }

        .mobile-sheet-navigation {
            display: none;
            width: 100%;
            background-color: $blackish;
            color: $white;

            @media #{$mq_phone} {
                display: block;
            }

            .dropdown-trigger {
                flex: 1;

                .navbar-item {
                    width: 100%;
                    height: $product-sheet-navigation-height;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    text-transform: uppercase;
                    font-weight: bold;
                    padding: 0 20px 0 65px;

                    .burger {
                        content: ' ';
                        display: block;
                        width: 37px;
                        height: 35px;
                        border-radius: 5px;
                        border: 1px solid #fff;
                        position: absolute;
                        top: 13px;
                        left: 15px;
                        padding: 7px 3px;

                        &-line {
                            display: block;
                            background: #fff;
                            width: 25px;
                            height: 3px;
                            margin: auto auto 5px;
                            transition: all $duration $easeInOutBack;
                        }
                    }
                }
            }

            .dropdown-menu {
                border-top: 1px solid $white;
                padding: 0;
                width: 100%;

                .dropdown-content {
                    padding: 0;
                    background-color: $blackish;

                    .has-link {
                        height: $product-sheet-navigation-height;

                        &:not(:last-child) {
                            border-bottom: 1px solid $dark-slate-gray;
                        }

                        .mobile-sheet-navigation-link {
                            display: flex;
                            align-items: center;
                            padding-left: 20px;
                            width: 100%;
                            height: 100%;
                            color: $white;

                            &.router-link-active {
                                text-decoration: underline;
                            }
                        }
                    }
                }
            }

            &.is-active {
                .burger {
                    &-line {
                        transition: all $duration $easeInOutBack;

                        &:first-child {
                            transform: rotate(43deg) translate(6px, 6px);
                        }

                        &:nth-child(2) {
                            width: 0;
                        }

                        &:last-child {
                            transform: rotate(-43deg) translate(5px, -6px);
                        }
                    }
                }
            }
        }
    }
</style>
